import axios from 'axios'
import router from '../router'
import { base64Jiami, getUserInfoCache } from '@/tools/common';

import { Toast } from 'vant';

export const newClient = function () {

  let apiCommon='';
  let token='';
  let userInfo = getUserInfoCache();
  apiCommon = base64Jiami({
    token: userInfo ? userInfo.token : ''
  });
  const newClient = axios.create({
    baseURL: process.env.baseURL,
    timeout: 2*60*1000,
    headers: {
      "systoken": token,
      "api_common":apiCommon,
    },
    withCredentials: true,
  })
  newClient.interceptors.response.use((response) => {
    const data = response.data
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      // 文件下载
      return response;
    }
    if(data.code === 40003){
      Toast(window.rootApp.$t('m.device_is_more'));
    } else if(data.code === 40006){
      Toast(window.rootApp.$t('m.Operation_failed'));
    } else {
      return response;
    }
  }, (error) => {
    // 超时错误本地化：把 axios 默认的 "timeout of xxxms exceeded" 改成"网络繁忙"
    // 调用方通常 Toast(error.message)，改 message 即可让显示对的文案，不主动 Toast 避免干扰静默接口
    if (error && (error.code === 'ECONNABORTED' || (error.message && /timeout/i.test(error.message)))) {
      try {
        const msg = (window.rootApp && window.rootApp.$t) ? window.rootApp.$t('m.netword_busy_try') : 'Network busy, please try again';
        error.message = msg;
      } catch (e) {}
    }
    return Promise.reject(error)
  })
  return newClient
}



// WEBPACK FOOTER //
// ./src/api/axios-client-old.js